export default "__VITE_ASSET__eb775c6f__"